import { CostCenterAssignmentsQuery } from 'generated/resources/graphql'

export type CostCenterAssignment =
  CostCenterAssignmentsQuery['finance']['costCenterMembershipsConnection']['nodes'][number]

export interface FormattedAssignment {
  id: string
  name: string
  costCenterId?: number | null
  percentage: number
  startDate: string
  endDate?: string
}

export interface FormattedAssignmentWithDeletion extends FormattedAssignment {
  markedForDeletion?: boolean
}

export const formatAssignments = (assignments: CostCenterAssignment[]): FormattedAssignment[] => {
  return assignments.map((assignment) => ({
    id: String(assignment.id),
    name: assignment.costCenter.name,
    percentage: assignment.percentage,
    startDate: assignment.startDate,
    endDate: assignment.endDate ?? undefined,
    costCenterId: assignment.costCenter.id,
  }))
}
